/* eslint-disable max-len */
import React from 'react';

const H5Icon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
    <path
      fill="currentColor"
      d="M2.75 14.996v-4.508H7.3v4.508h1.75V5H7.3v3.976H2.75V5H1v9.996h1.75zm11.256.196c.597 0 1.11-.11 1.54-.329.43-.22.782-.5 1.057-.84.275-.34.476-.719.602-1.134.126-.415.189-.819.189-1.211 0-.467-.068-.9-.203-1.302-.135-.401-.334-.749-.595-1.043-.261-.294-.583-.523-.966-.686-.383-.163-.817-.245-1.302-.245-.327 0-.656.063-.987.189-.331.126-.604.31-.819.553l-.028-.028.504-2.492h3.878V5.196h-5.068l-1.05 5.362h1.596c.13-.345.343-.581.637-.707s.609-.189.945-.189c.317 0 .595.056.833.168.238.112.432.261.581.448.15.187.261.404.336.651.075.247.112.506.112.777 0 .299-.03.579-.091.84-.06.261-.163.49-.308.686-.145.196-.334.35-.567.462-.233.112-.518.168-.854.168-.523 0-.943-.142-1.26-.427-.317-.285-.5-.693-.546-1.225h-1.596c.019.495.119.926.301 1.295.182.369.427.679.735.931s.665.441 1.071.567c.406.126.847.189 1.323.189z"
    />
  </svg>
);

export default H5Icon;
